import { SelectionSpouseEventDetails, SelectionEvent } from './internal';
export class SelectionFamilyEvent extends SelectionEvent {
    getHusbandDetails() {
        return this.get("HUSB" /* Tag.Husband */, null, SelectionSpouseEventDetails);
    }
    getWifeDetails() {
        return this.get("WIFE" /* Tag.Wife */, null, SelectionSpouseEventDetails);
    }
}
//# sourceMappingURL=SelectionFamilyEvent.js.map